import { useQuery } from "hooks";

const getRolesQueryFactory = () => {
  const query = `query hubRoles {
    roles {
      edges {
        node {
          id
          title
        }
      }
    }
  }
  `;

  const resolver = ({ data }) => {
    return data.roles.edges.map(({ node }) => {
      return node;
    });
  };

  return { query, resolver };
};

const useGetRoles = () => {
  const { data, loading } = useQuery(getRolesQueryFactory);

  return {
    defaultRole: data.find((d) => {
      return d.title === "User";
    }),
    data: data,
    loading: loading,
  };
};

export default useGetRoles;
